module.exports = __webpack_public_path__ + "static/media/2.ddf0742c.svg";